/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import appConfig from '@bingads-webui-component-legacy/config/index';
import appState from '@bingads-webui-component-legacy/state/index';
import * as instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import * as columnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences';
import * as legacyColumnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/legacy-column-chooser-preferences';
import * as customColumnPreference from '@bingads-webui-component-legacy/bingads-grid/service/custom-column-preferences';
import * as legacyGridFlagPreference from '@bingads-webui-component-legacy/bingads-grid/service/legacy-grid-flag-preferences';
import * as gridDownloadAdapter from '@bingads-webui-campaign-legacy/griddownload/view/adapter';
import * as edm from '@bingads-webui-component-legacy/edm-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';


const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!global');
const dimensionI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dimension');


export const dimensionsGridLegacyDepsList = {
  'component/edm-campaign/index': edm,
  'component/js-data-campaign/index': jsdata,
  '$/i18n!global': i18nGlobal,
  'campaignui/feature/instrumentation/index': instrumentation,
  'component/state/index': appState,
  'component/bingads-grid/service/column-chooser-preferences': columnChooserPreference,
  'component/bingads-grid/service/legacy-column-chooser-preferences': legacyColumnChooserPreference,
  'component/bingads-grid/service/custom-column-preferences': customColumnPreference,
  'component/bingads-grid/service/legacy-grid-flag-preferences': legacyGridFlagPreference,
  'campaignui/feature/griddownload/view/adapter': gridDownloadAdapter,
  '@bingads-webui/i18n-amd-loader!campaignui/feature/dimension': dimensionI18n,
  'component/config/index': appConfig,
};
